module.exports = "https://cdn.hellotech.com/client-assets/target-easyinstall_59bc257c01a8d49978488239129dc561.svg";